<template>
  <div class="background-box">
    <div class="success-box">
      <div class="success-title">
        提交成功
      </div>
      <div class="success-content">
        <div class="success-content-img-persion" />
        <div class="success-content-img-paper">
          <div class="success-img-box">
            <img src="../../../public/checkmark.png" alt="paper" class="success-img-box-img">
            <div class="success-img-box-text">
              稍后将由经销商<br>与您1对1进行沟通
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Success'
}
</script>

<style scoped>
.background-box {
  width: 100vw;
  height: 100vh;
  background-image: url('../../../public/bg.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.success-box {
  width: 100%;
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.success-title {
  margin-top: 20px;
  font-weight: bold;
  font-size: 85px;
  color: #fff;
  text-align: center;
  text-shadow: blue 2px 0 0, blue 0 2px 0, blue -2px 0 0, blue 0 -2px 0;
}
.success-content {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px;
}
.success-content-img-persion {
  width: 100%;
  height: 140px;
  background-image: url('../../../public/person.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.success-content-img-paper {
  position: relative;
  top: -10px;
  width: 100%;
  height: 340px;
  background-image: url('../../../public/paper.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.success-img-box {
  position: absolute;
  top: -10;
  width: 100%;
  height: 100%;
  text-align: center;
}
.success-img-box-img {
  position: relative;
  top: 20px;
  width: 150px;
  height: 150px;
}
.success-img-box-text {
  font-size: 26px;
  position: relative;
  font-weight: bold;
}
</style>
